import * as Sentry from '@sentry/react';
import {createRoot} from 'react-dom/client';
import TagManager from 'react-gtm-module';

import json from '../package.json';
import './index.css';
import App from './App';
import {AUTOCUT_CONSTANTS} from './constants/configs';
import {OutputProvider} from './contexts/OutputContext';
import {
  CURRENT_ENV,
  Env,
  IS_RUNNING_ON_ELECTRON,
} from './utils/currentEnv.utils';

// This function allows to stringify an Error object
// It will be used for Sentry and the logger
// https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
if (!('toJSON' in Error.prototype))
  Object.defineProperty(Error.prototype, 'toJSON', {
    value: function () {
      const alt: any = {};

      Object.getOwnPropertyNames(this).forEach(function (key: any) {
        // @ts-ignore
        alt[key] = this[key];
      }, this);

      return alt;
    },
    configurable: true,
    writable: true,
  });

const tagManagerArgs = {
  gtmId: AUTOCUT_CONSTANTS[CURRENT_ENV].GTM_ID,
};

const SENTRY_ENV = CURRENT_ENV as string;

Sentry.init({
  dsn: 'https://045b82f7582533d60e7c9b8131c554f5@o4504764662087680.ingest.us.sentry.io/4509327599009792',
  environment: SENTRY_ENV,
  enabled: ['development', 'production', 'qa-staging', 'staging'].includes(
    SENTRY_ENV,
  ),
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: ['development', 'qa-staging', 'staging'].includes(
    SENTRY_ENV,
  )
    ? 1.0
    : 0.1,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: ['development', 'qa-staging', 'staging'].includes(
    SENTRY_ENV,
  )
    ? 1.0
    : 0.1,
  release: `autocut-extension-v3@${json.version}`,
  ignoreErrors: [
    /.*Reference QT Chapter track not found.*/,
    /.*co located POCs unavailable.*/,
  ],
  sendDefaultPii: true,

  // integrations: [new Sentry.Replay()],
});

TagManager.initialize(tagManagerArgs);

const root = createRoot(document.getElementById('root') as HTMLElement);

if (IS_RUNNING_ON_ELECTRON || CURRENT_ENV === Env.Development) {
  root.render(
    <OutputProvider>
      <App />
    </OutputProvider>,
  );
} else {
  window.location.href = 'autocut://onboarding';
  window.location.href = 'https://www.autocut.com';
}
